<template>
    <van-popup class="report-act-remind-popup-box report-act-repay-popup-box" v-bind:value="showReportRepayPopup" v-bind:close-on-click-overlay="false">
        <div class="report-act-popup-close" @click="clickClose"><span class="close"></span></div>
        <div class="report-act-repay-popup">
            <div class="report-act-repay-pp-content">
                <p>重新生成此部分报告将会以当前时间为起点，重新生成未来时间对应的图表及解析，将会覆盖现有内容。</p>
            </div>
            <div v-if="userVip >= 20" class="report-act-repay-pp-btn-box box-mid">
                <button class="report-rbul-button report-rbul-button-2" @click="clickRePayConfirm">确认重新生成<span class="report-act-repay-pp-tips"></span></button>
            </div>
            <div v-else class="report-act-repay-pp-btn-box">
                <button class="report-rbul-button report-rbul-button-2" @click="clickRePay">{{curReportRepayProductData.price}}元 重新生成</button>
                <button class="report-rbul-button report-rbul-button-3" @click="clickVip">优惠开通终身会员<span class="report-act-repay-pp-tips"></span></button>
                <p class="report-act-repay-pp-note" v-if="vipProductData['pay_40020']">
                    <span class="blue">活动特别优惠{{ vipProductData['pay_40020'].price }}</span><span class="span-through">原价{{ vipProductData['pay_40020'].rate_price }}</span>
                </p>
            </div>
        </div>
    </van-popup>
</template>

<script>
import { CONFIG } from '../../modules/config'
import { MIX } from '../../modules/utils';
export default {
    name: 'ReportRePayPopup',
    computed: {
        userVip() {
            return this.$store.state.userData && this.$store.state.userData.info ? this.$store.state.userData.info.vip : 0;
        },
        showReportRepayPopup() {
            return this.$store.state.report.showReportRepayPopup
        },
        curReportRepayProductData() {
            return this.$store.state.report.curReportRepayProductData
        },
        vipProductData() {
            return this.$store.state.pay.vipProductData;
        },
    },
    methods: {
        clickClose() {
            // 隐藏弹框
            this.$store.state.report.showReportRepayPopup = false;
        },
        clickRePayConfirm() {
            let detailInfo = this.$store.state.report.detailInfo;
            let reportData = this.$store.state.report.reportData;
            let productData = Object.assign({}, this.curReportRepayProductData);
            //0:全部, 1:月, 2:天赋, 3:五年, 4:总历程
            // 天赋:pay_31100; 月:pay_10001; 5年:pay_10003; 总:pay_10004
            let typeData = {"pay_31100": 2, 'pay_10001': 1, 'pay_10003': 3, 'pay_10004': 4 }
            let type = productData && productData.pid ? typeData[productData.pid] : 0;
            console.log('clickRePayConfirm---', detailInfo, reportData, productData, type);
            this.$store.dispatch('report/freeUnlockReport', {
                detailInfo: detailInfo,
                type: type,
                frompage: 'report',
                sucCb: () => {
                    this.$toast('成功重新生成~');
                    this.$store.state.report.showReportRepayPopup = false;
                },
                failCb: function() {
                    this.$toast('免费解锁失败，请稍后再试');
                }
            });
        },
        clickRePay() {
            let detailInfo = this.$store.state.report.detailInfo;
            let productData = Object.assign({}, this.curReportRepayProductData);
            var payType = CONFIG.platform == 'qq' ? 'wx_qr' : 'wx_pub';

            if(detailInfo == null || productData == null) {
                this.$toast('商品出错，请刷新稍后再试')
                return;
            }
            console.log('clickRePay-----', detailInfo, productData);
            MIX.trackButtonClicked('regenerate__bt');

            this.$store.dispatch('pay/createPayOrder', {
                params: {
                    pid: productData.pid,              //支付项目id
                    ptype: payType,                    //支付方式
                    ext: detailInfo.id                 //支付的评测id
                },
                mixParams: {
                    pid: productData.pid,
                    product_name: productData.title,
                    price: productData.price,
                    from: 'generate_again',
                },
                sucCb: () => {
                    console.log('支付成功，更新测评报告数据');
                    this.$store.state.report.showReportRepayPopup = false;
                    this.$store.dispatch('report/updateReportShowTimeAndActData');
                    // 更新测验报告数据
                    if(detailInfo) {
                        this.$store.dispatch('report/updateReportInfo', detailInfo.id);
                    }
                    // 更新ai状态
                    this.$store.state.detail.personInfo.ai = 1;
                    this.$store.dispatch('record/updateRecordListAIStatus', {
                        id: detailInfo.id
                    });

                }
            });
        },
        clickVip() {
            MIX.trackButtonClicked('regenerate_to_vip_bt');
            this.$store.state.activity.showActAlwaysDiscountPop = true;
            setTimeout(() => {
                MIX.trackPageViewed('ForeverVipBannerPage', 'regenerate');
            }, 100);
        }
    }
}
</script>
